import React, { useEffect, useState } from "react";
import s from "../../admin_styles/UserSearch.module.css";

const initialFilters = {
  user_id: "",
  without_user: false,
  direction: "",
  status: "",
  q: "",
};

export default function EmailMessagesPanel() {
  const [filters, setFilters] = useState(initialFilters);
  const [loading, setLoading] = useState(false);
  const [messages, setMessages] = useState([]);
  const [chains, setChains] = useState([]);
  const [selectedMessage, setSelectedMessage] = useState(null);

  const getMessagePreview = (item) => {
    const textSource = (item?.body_text || "").replace(/\s+/g, " ").trim();
    if (textSource) {
      return textSource.slice(0, 120) + (textSource.length > 120 ? "..." : "");
    }

    const htmlSource = (item?.body_html || "")
      .replace(/<style[\s\S]*?<\/style>/gi, " ")
      .replace(/<script[\s\S]*?<\/script>/gi, " ")
      .replace(/<[^>]+>/g, " ")
      .replace(/\s+/g, " ")
      .trim();

    if (!htmlSource) return "-";
    return htmlSource.slice(0, 120) + (htmlSource.length > 120 ? "..." : "");
  };

  const buildQuery = () => {
    const params = new URLSearchParams();
    if (filters.user_id.trim()) params.set("user_id", filters.user_id.trim());
    if (filters.without_user) params.set("without_user", "1");
    if (filters.direction) params.set("direction", filters.direction);
    if (filters.status) params.set("status", filters.status);
    if (filters.q.trim()) params.set("q", filters.q.trim());
    params.set("limit", "100");
    return params.toString();
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const qs = buildQuery();
      const [messagesRes, chainsRes] = await Promise.all([
        fetch(`/api/admin/email/messages?${qs}`),
        fetch(`/api/admin/email/chains?${qs}`),
      ]);

      const messagesData = await messagesRes.json().catch(() => ({}));
      const chainsData = await chainsRes.json().catch(() => ({}));

      setMessages(messagesData.items || []);
      setChains(chainsData.items || []);
    } catch (err) {
      console.error("Ошибка загрузки email-данных", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        setSelectedMessage(null);
      }
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  return (
    <div style={{ marginTop: 12 }}>
      <h3>Все письма</h3>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))", gap: 8 }}>
        <input
          type="number"
          placeholder="user_id"
          value={filters.user_id}
          onChange={(e) => setFilters((p) => ({ ...p, user_id: e.target.value }))}
        />

        <select
          value={filters.direction}
          onChange={(e) => setFilters((p) => ({ ...p, direction: e.target.value }))}
        >
          <option value="">Направление</option>
          <option value="inbound">Входящие</option>
          <option value="outbound">Исходящие</option>
        </select>

        <select
          value={filters.status}
          onChange={(e) => setFilters((p) => ({ ...p, status: e.target.value }))}
        >
          <option value="">Статус</option>
          <option value="queued">queued</option>
          <option value="sent">sent</option>
          <option value="delivered">delivered</option>
          <option value="failed">failed</option>
          <option value="received">received</option>
        </select>

        <label style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <input
            type="checkbox"
            checked={filters.without_user}
            onChange={(e) => setFilters((p) => ({ ...p, without_user: e.target.checked }))}
          />
          без user_id
        </label>

        <input
          type="text"
          placeholder="Поиск по содержимому"
          value={filters.q}
          onChange={(e) => setFilters((p) => ({ ...p, q: e.target.value }))}
        />

        <button onClick={fetchData} disabled={loading}>
          {loading ? "Загрузка..." : "Применить"}
        </button>
      </div>

      <div className={s.tableWrapper} style={{ marginTop: 10 }}>
        <h4>Группировка по пользователю/почте</h4>
        <table className={s.table}>
          <thead>
            <tr>
              <th>Группа</th>
              <th>User ID</th>
              <th>Всего</th>
              <th>Входящих</th>
              <th>Исходящих</th>
              <th>Ошибок</th>
              <th>Последнее</th>
            </tr>
          </thead>
          <tbody>
            {chains.map((chain) => (
              <tr key={chain.group_label}>
                <td>{chain.group_label?.replace(/^(user:|email:)/, '')}</td>
                <td>{chain.user_id ?? "-"}</td>
                <td>{chain.total_messages}</td>
                <td>{chain.inbound_count}</td>
                <td>{chain.outbound_count}</td>
                <td>{chain.failed_count}</td>
                <td>{chain.last_message_at || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className={s.tableWrapper} style={{ marginTop: 10 }}>
        <h4>Письма</h4>
        <table className={s.table}>
          <thead>
            <tr>
              <th>ID</th>
              <th>User ID</th>
              <th>Direction</th>
              <th>Status</th>
              <th>From</th>
              <th>To</th>
              <th>Subject</th>
              <th>текст письма</th>
              <th>Rank</th>
              <th>Дата</th>
            </tr>
          </thead>
          <tbody>
            {messages.map((item) => (
              <tr key={item.id}>
                <td>{item.id}</td>
                <td>{item.user_id ?? "-"}</td>
                <td>{item.direction}</td>
                <td>{item.status}</td>
                <td>{item.from_email || "-"}</td>
                <td>{item.to_email || "-"}</td>
                <td title={item.body_text || ""}>{item.subject || "-"}</td>
                <td
                  onClick={() => setSelectedMessage(item)}
                  style={{
                    maxWidth: 340,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    cursor: "pointer",
                    color: "#0b5ed7",
                  }}
                  title="Открыть письмо"
                >
                  {getMessagePreview(item)}
                </td>
                <td>{item.rank_score ?? 0}</td>
                <td>{item.created_at || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {selectedMessage && (
        <div
          onClick={() => setSelectedMessage(null)}
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0, 0, 0, 0.45)",
            zIndex: 1200,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 12,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              width: "min(980px, 100%)",
              maxHeight: "92vh",
              background: "#fff",
              borderRadius: 12,
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "10px 14px",
                borderBottom: "1px solid #e7e7e7",
                gap: 8,
                flexWrap: "wrap",
              }}
            >
              <div style={{ fontSize: 13, color: "#2b2b2b" }}>
                <strong>{selectedMessage.subject || "Без темы"}</strong>
                <div style={{ marginTop: 4, color: "#666" }}>
                  From: {selectedMessage.from_email || "-"} | To: {selectedMessage.to_email || "-"}
                </div>
              </div>
              <button onClick={() => setSelectedMessage(null)}>Закрыть</button>
            </div>

            <div style={{ padding: 12, overflow: "auto" }}>
              {selectedMessage.body_html ? (
                <iframe
                  title={`email-${selectedMessage.id}`}
                  srcDoc={selectedMessage.body_html}
                  style={{
                    width: "100%",
                    minHeight: "65vh",
                    border: "1px solid #ececec",
                    borderRadius: 8,
                    background: "#fff",
                  }}
                />
              ) : (
                <pre
                  style={{
                    margin: 0,
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                    fontFamily: "inherit",
                    lineHeight: 1.45,
                    fontSize: 14,
                  }}
                >
                  {selectedMessage.body_text || "Тело письма пустое"}
                </pre>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
